/**
 * TanStack Query hooks for `custom-currency-per-invoice`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customCurrencyPerInvoiceQueryKeys,
	type CreateCustomCurrencyPerInvoiceBody,
	type ListCustomCurrencyPerInvoiceResponse,
	type CustomCurrencyPerInvoiceRow,
} from "./api";

export function useCustomCurrencyPerInvoiceList(): UseQueryResult<ListCustomCurrencyPerInvoiceResponse, Error> {
	return useQuery({
		queryKey: customCurrencyPerInvoiceQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomCurrencyPerInvoiceCreate(): UseMutationResult<CustomCurrencyPerInvoiceRow, Error, CreateCustomCurrencyPerInvoiceBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customCurrencyPerInvoiceQueryKeys.all });
		},
	});
}

export function useCustomCurrencyPerInvoiceDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customCurrencyPerInvoiceQueryKeys.all });
		},
	});
}
